const dateFormat = (strdate) => {
    let date = new Date(strdate)
    let day = date.getDate()
    let month = date.toLocaleString('default', { month: 'short' }).replace('.','').split('')
    month[0] = month[0].toUpperCase()
    let year = date.getFullYear()
    return `${day}/${month.join('')}/${year}`
}

export default dateFormat;